import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import Scrollbar from 'src/components/scrollbar';

const WeeklyPayrolltableView = ({ data }) => {
    console.log("🚀 ~ WeeklyPayrolltableView>>>>>", data)

    const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    const CompleteDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    return (
        <TableContainer component={Paper}>
            <Scrollbar>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell rowSpan={2} sx={{ fontWeight: 'bold', border: '1px solid #e0e0e0' }}>Name</TableCell>
                            <TableCell rowSpan={2} sx={{ fontWeight: 'bold', border: '1px solid #e0e0e0' }}>Backcharge</TableCell>
                            <TableCell rowSpan={2} sx={{ fontWeight: 'bold', border: '1px solid #e0e0e0' }}>Union No.</TableCell>
                            <TableCell rowSpan={2} sx={{ fontWeight: 'bold', border: '1px solid #e0e0e0' }}>SS#</TableCell>
                            <TableCell rowSpan={2} sx={{ fontWeight: 'bold', border: '1px solid #e0e0e0' }}>Trade</TableCell>

                            {/* Loop through the days array and match it with data.days */}
                            {data?.days?.map((day, index) => (
                                <TableCell key={index} colSpan={3} sx={{ fontWeight: 'bold', border: '1px solid #e0e0e0' }}>
                                    {days[index]} ({day?.month} {day?.day})
                                </TableCell>
                            ))}
                            <TableCell rowSpan={2} sx={{ fontWeight: 'bold', border: '1px solid #e0e0e0' }}>Total Hrs</TableCell>
                        </TableRow>
                        <TableRow>
                            {data?.days?.map(() => (
                                <>
                                    <TableCell sx={{ fontWeight: 'bold', border: '1px solid #e0e0e0' }}>Time In</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', border: '1px solid #e0e0e0' }}>Out</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', border: '1px solid #e0e0e0 !important' }}>Hrs</TableCell>
                                </>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data?.weekly_time_sheets?.map((employeeEntries, empIndex) => (
                            employeeEntries?.map((entry, entryIndex) => (
                                entryIndex === 0 && ( // Ensure each employee is rendered only once per week
                                    <TableRow key={empIndex} >
                                        <TableCell sx={{ border: '1px solid #e0e0e0' }}>
                                            {entry?.employee?.first_name} {entry.employee?.last_name}
                                        </TableCell>
                                        <TableCell sx={{ border: '1px solid #e0e0e0' }}>
                                            {entry?.Backcharge || ' '}
                                        </TableCell>
                                        <TableCell sx={{ border: '1px solid #e0e0e0' }}>
                                            {entry.employee?.union || ' '}
                                        </TableCell>
                                        <TableCell sx={{ border: '1px solid #e0e0e0' }}>
                                            {entry.employee.social_security_number || ' '}
                                        </TableCell>
                                        <TableCell sx={{ border: '1px solid #e0e0e0' }}>
                                            {entry.trade_worker_title?.name || ' '}
                                        </TableCell>
                                        {employeeEntries?.map((dayEntry, index) => (
                                            <React.Fragment key={index}>
                                                <TableCell sx={{ border: '1px solid #e0e0e0' }}>
                                                    {dayEntry.formatted_start_time || '--'}
                                                </TableCell>
                                                <TableCell sx={{ border: '1px solid #e0e0e0' }}>
                                                    {dayEntry.formatted_finish_time || '--'}
                                                </TableCell>
                                                <TableCell sx={{ border: '1px solid #e0e0e0' }}>
                                                    {dayEntry.total_time_hours || '0'}
                                                </TableCell>
                                            </React.Fragment>
                                        ))}
                                        <TableCell sx={{ border: '1px solid #e0e0e0' }}>
                                            {employeeEntries.reduce((acc, day) => acc + (day.total_time_hours || 0), 0)}
                                        </TableCell>
                                    </TableRow>
                                )
                            ))
                        ))}
                        <TableRow sx={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>
                            <TableCell colSpan={5} sx={{ border: '1px solid #e0e0e0', fontWeight: 'bold' }}>
                                Totals
                            </TableCell>

                            {CompleteDays.map((day, index) => (
                                <React.Fragment key={index}>
                                    <TableCell sx={{ border: '1px solid #e0e0e0' }}></TableCell>
                                    <TableCell sx={{ border: '1px solid #e0e0e0' }}></TableCell>
                                    <TableCell sx={{ border: '1px solid #e0e0e0', fontWeight: 'bold' }}>
                                        {data?.sub_totals?.[`total${day}Hours`] || 0}
                                    </TableCell>
                                </React.Fragment>
                            ))}

                            <TableCell sx={{ border: '1px solid #e0e0e0', fontWeight: 'bold' }}>
                                {data?.grand_total || 0}
                            </TableCell>
                        </TableRow>

                    </TableBody>

                </Table>
            </Scrollbar>
        </TableContainer>
    );
};

export default WeeklyPayrolltableView;
